import { createIcon } from './createIcon';

const Close = createIcon(
  'Close',
  <>
    <path d="M18 6L6 18" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 6L18 18" strokeLinecap="round" strokeLinejoin="round" />
  </>,
);

export default Close;
